export default __webpack_public_path__ + "static/media/banner2.1200b6d2.png";